import styles from "./styles.module.scss";
import _ from "lodash";
import cx from "classnames";

interface SegmentButtonProps {
  listOfSegments: string[];
  selected?: string | undefined;
  onChange: (val: string) => void;
} 

const SegmentButton = ({ listOfSegments, selected, onChange }: SegmentButtonProps) => {
  return (
    <div className={styles.container}>
      {_.map(listOfSegments, (item, index) => (
          <p
            key={index}
            className={cx(styles.content, {
              [styles.selectedContent]: selected === item,
            })}
            onClick={() => onChange(item)}
          >
            <i className={cx("paperflite-tick", styles.icon, {[styles.activeIcon]: selected && selected === item})} />
            {" "}
            {item}
          </p>
      ))}
    </div>
  );
};

export default SegmentButton;
